import { ShopService } from '@common/lib/api';
import to from '@common/lib/common/to';
import * as shop from './types';
//import * as common from '@common/store/modules/common/types';
//import * as commonGetters from '@common/store/modules/common/getters';

const actions = {
  async [shop.SHOP_MESSAGE_INSERT](context, params) {
    const { data } = await ShopService.setStoreMessage(params);
    //context.commit(shop.SET_SHOP, data);
    return data;
  },
  async [shop.SHOP_MESSAGE_DELETE](context, params) {
    const { data } = await ShopService.setStoreMessageDel(params);
    // context.commit(shop.SET_SHOP, data);
    return data;
  },
  async [shop.FETCH_SHOP](context, params) {
    const { data } = await ShopService.getById(params);
    context.commit(shop.SET_SHOP, data);
    return data;
  },
  async [shop.FETCH_SHOPS](context, params) {
    const { data } = await ShopService.me(params);
    context.commit(shop.SET_SHOPS, data);
    return data;
  },
  async [shop.FETCH_RECOMMEND_SHOPS](context, params) {
    const { data } = await ShopService.recommend(params);
    context.commit(shop.SET_RECOMMEND_SHOPS, data);
    return data;
  },
  async [shop.SHOP_FOLLOW](context, payload) {
    const { data } = await ShopService.follow(payload);
    return data;
  },
  async [shop.SHOP_UNFOLLOW](context, payload) {
    const { data } = await ShopService.unFollow(payload);
    return data;
  },
  async [shop.FETCH_SHOP_BY_USERID](context, params) {
    const { data } = await ShopService.getStoreByUserId(params);
    context.commit(shop.SET_SHOP, data);
    return data;
  },
  async [shop.FETCH_SHOP_ME](context, payload) {
    const { data } = await ShopService.getStoreByUserId(payload);
    context.commit(shop.SET_SHOP, data);
    return data;
  },
  // 검색매장 리스트
  async [shop.FETCH_SHOPS_SEARCH](context, params) {
    const { data } = await ShopService.search(params);
    context.commit(shop.SET_SHOPS, data);
    return data;
  },
  // 사전승낙서 가져오기
  async [shop.FETCH_SHOP_PRIOR_CONSENT](context, params) {
    const { data } = await ShopService.getStorePriorConsent(params);
    context.commit(shop.SET_SHOP_PRIOR_CONSENT, data);
    return data;
  },
  // 사전승낙서 저장하기
  async [shop.SET_SHOP_PRIOR_CONSENT](context, params) {
    const { data } = await ShopService.setStorePriorConsent(params);
    return data;
  },
  // 열람권 리스트 가져오기
  async [shop.FETCH_SHOP_VOUCHERS](context, params) {
    const { data } = await ShopService.getStoreVouchers(params);
    console.log('FETCH_SHOP_VOUCHERS :: {}', data);
    context.commit(shop.SET_SHOP_VOUCHERS, data);
    return data;
  },
  // 열람권 개수 조회
  async [shop.FETCH_SHOP_VOUCHERS_COUNT](context, params) {
    const { data } = await ShopService.getVouchersCnt(params);
    return data;
  },
  // 열람권 사용
  async [shop.FETCH_SHOP_VOUCHERS_USE](context, params) {
    const { data } = await ShopService.setStoreVouchersUse(params);
    context.commit(shop.SET_SHOP_VOUCHERS_USE, data);
    return data;
  },
  // 매장 비대면(온라인) 판매 신청
  async [shop.SHOP_ONLINE_APPLY](context, params) {
    const { data } = await ShopService.setOnlineApply(params);
    return data;
  },
  // 관심매장 등록 고객 리스트
  async [shop.FETCH_FOLLOWERS](context, payload) {
    const { data } = await ShopService.getFollowers(payload);
    return data;
  },
};

export default actions;
